import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";

const stats = [
  { value: "1,280+", label: "收录短剧" },
  { value: "3,400+", label: "演员资料" },
  { value: "860", label: "花絮长文" },
  { value: "8.2", label: "平均口碑分" },
];

const quickTags = ["假千金", "长公主", "甜宠", "悬疑烧脑", "古装权谋"];

const ticker = [
  "《长公主在上》朝堂大戏幕后曝光",
  "《末班地铁的陌生人》结局七处线索",
  "《民国小厨娘》四十六道菜怎么拍",
  "《重生之假千金上门》口碑持续攀升",
  "短剧后期剪辑到底在忙什么",
];

export default function HeroSection() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const submit = (event: FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) return;
    navigate(`/dramas?q=${encodeURIComponent(value)}`);
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20background%20of%20a%20vintage%20movie%20theatre%20with%20deep%20crimson%20velvet%20curtains%2C%20warm%20golden%20spotlight%20beams%2C%20blurred%20bokeh%20lights%2C%20moody%20dramatic%20atmosphere%2C%20rich%20textured%20fabric%2C%20editorial%20photography&width=1800&height=1000&seq=duanju-hero-main&orientation=landscape"
          alt="短剧爆料社 沉浸式剧场背景"
          title="爆料短剧 演员表查询 导演编剧信息"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-secondary-950/40 via-secondary-950/25 to-secondary-950/50" />

      <div className="relative mx-auto flex w-full max-w-content flex-col items-center px-4 pb-16 pt-20 text-center md:px-6 md:pb-24 md:pt-28">
        <span className="animate-rise inline-flex items-center gap-2 rounded-full border border-background-50/40 bg-background-50/10 px-4 py-1.5 text-xs tracking-[0.18em] text-background-50 backdrop-blur-sm">
          <i className="ri-radar-line"></i>
          爆料短剧 · 主创情报站
        </span>

        <h1 className="animate-rise mt-6 font-heading text-4xl font-black leading-tight tracking-tight text-background-50 md:text-6xl">
          短剧爆料社
        </h1>
        <p className="animate-rise mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          想查爆料短剧的演员表查询、导演编剧信息，这里都给你列全。拍摄花絮和幕后制作故事揭秘镜头背后的操作，
          剧集口碑评分帮你判断值不值得追。主创阵容、制作内幕、观众评价，一次看明白。
        </p>

        <form
          onSubmit={submit}
          role="search"
          className="animate-rise mt-8 flex w-full max-w-xl flex-col items-stretch gap-2 rounded-full border border-background-50/30 bg-background-50/90 p-2 backdrop-blur-sm sm:flex-row sm:items-center"
        >
          <span className="hidden h-8 w-8 items-center justify-center pl-2 text-foreground-500 sm:flex">
            <i className="ri-search-2-line text-lg"></i>
          </span>
          <input
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="输入剧名或演员姓名，例如：长公主在上"
            aria-label="搜索短剧或演员"
            className="w-full flex-1 bg-transparent px-4 py-2 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 sm:px-1"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            立即查询
          </button>
        </form>

        <div className="animate-rise mt-4 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-background-200">大家在搜：</span>
          {quickTags.map((tag) => (
            <Link
              key={tag}
              to={`/dramas?q=${encodeURIComponent(tag)}`}
              className="rounded-full border border-background-50/30 px-3 py-1 text-xs text-background-50 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              {tag}
            </Link>
          ))}
        </div>

        <dl className="animate-rise mt-12 grid w-full max-w-3xl grid-cols-2 gap-y-6 border-t border-background-50/20 pt-8 md:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label} className="flex flex-col items-center">
              <dt className="order-2 mt-1 text-xs text-background-200">{item.label}</dt>
              <dd className="order-1 font-heading text-2xl font-bold text-accent-400 md:text-3xl">
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative w-full overflow-hidden border-t border-background-50/15 bg-secondary-950/60 py-3 backdrop-blur-sm">
        <div className="flex w-max animate-marquee items-center gap-10">
          {[...ticker, ...ticker].map((text, index) => (
            <span key={`${text}-${index}`} className="flex items-center gap-2.5 whitespace-nowrap text-xs text-background-100">
              <span className="flex h-4 w-4 items-center justify-center text-accent-400">
                <i className="ri-flashlight-fill text-xs"></i>
              </span>
              {text}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}